<div class="">
  <!-- Version display — above Notifications, only visible when menu is open -->
  <div
    [ngClass]="{ hidden: !isMenuOpen }"
    class="w-full px-4 py-2.5 flex flex-row items-center gap-3 text-xs text-base-content/60 bg-base-300"
  >
    <span class="font-medium">APGAP Version:</span>
    <span>FE v{{ appVersion }}</span>
    <span *ngIf="backendVersion">BE v{{ backendVersion }}</span>
  </div>
  <div [ngClass]="{ hidden: !isMenuOpen }" class="px-3 py-1 bg-base-300">
    <hr class="border-t border-base-300" />
  </div>

  <div *ngFor="let item of bottomMenuItems" class="w-full transition-colors" [ngClass]="{ hidden: !isMenuOpen }">
    <!-- Divider -->
    <div *ngIf="item.dividerAbove" class="px-3 py-1">
      <hr class="border-t border-base-300" />
    </div>

    <!-- Internal route link -->
    <a
      *ngIf="item.state !== 'sign-out' && !item.externalUrl"
      [routerLink]="['/' + item.state]"
      [queryParams]="queryParamsFor(item)"
      (click)="selectNavItem(item)"
      [ngClass]="{ active: isSelected(item) }"
      class="flex items-center justify-between px-4 py-2.5 rounded-md transition-colors cursor-pointer side-bottom-menu-item"
      [attr.data-tour-bottom]="item.name"
    >
      <div class="flex items-center space-x-3">
        <img
          *ngIf="getMenuIcon(item.name)"
          [src]="getMenuIcon(item.name)!"
          [alt]="item.name"
          class="w-5 h-5 side-bottom-icon"
        />
        <span class="text-sm text-base-content side-bottom-text">{{ item.name }}</span>
      </div>
      <span
        *ngIf="item.badgeCount && item.badgeCount > 0"
        class="badge badge-sm bg-primary-focus text-primary-content rounded-full min-w-[1.5rem] h-5 flex items-center justify-center px-2 text-xs"
      >
        {{ item.badgeCount }}
      </span>
    </a>

    <!-- External URL link -->
    <a
      *ngIf="item.externalUrl"
      [href]="item.externalUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="flex items-center justify-between px-4 py-2.5 rounded-md transition-colors cursor-pointer side-bottom-menu-item hover:bg-base-200"
    >
      <div class="flex items-center space-x-3">
        <img
          *ngIf="getMenuIcon(item.name)"
          [src]="getMenuIcon(item.name)!"
          [alt]="item.name"
          class="w-5 h-5 side-bottom-icon"
        />
        <span class="text-sm text-base-content side-bottom-text">{{ item.name }}</span>
      </div>
      <span
        *ngIf="item.badgeCount && item.badgeCount > 0"
        class="badge badge-sm bg-primary-focus text-primary-content rounded-full min-w-[1.5rem] h-5 flex items-center justify-center px-2 text-xs"
      >
        {{ item.badgeCount }}
      </span>
    </a>
    <button
      *ngIf="item.state === 'sign-out'"
      type="button"
      class="flex items-center justify-between w-full px-4 py-2.5 rounded-md transition-colors cursor-pointer bg-transparent border-0 text-left side-bottom-menu-item"
      [attr.data-tour-bottom]="item.name"
      (click)="logOut()"
    >
      <div class="flex items-center space-x-3">
        <img
          *ngIf="getMenuIcon(item.name)"
          [src]="getMenuIcon(item.name)!"
          [alt]="item.name"
          class="w-5 h-5 side-bottom-icon"
        />
        <span class="text-sm text-base-content side-bottom-text">{{ item.name }}</span>
      </div>
    </button>
  </div>

  <div class="">
    <div class="dropdown dropdown-top w-full">
      <button
        type="button"
        tabindex="0"
        (click)="toggleMenu()"
        class="w-full cursor-pointer flex items-center justify-between px-4 py-2.5 bg-primary hover:bg-opacity-90 transition-colors border-0 text-left"
      >
        <div class="flex items-center">
          <span class="text-sm text-primary-content font-medium">{{ userSignal()?.email }}</span>
        </div>
        <svg
          class="w-5 h-5 text-primary-content transition-transform duration-200"
          [ngClass]="{ 'rotate-180': isMenuOpen }"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
        </svg>
      </button>
    </div>
  </div>
</div>
